import OpenWithSharpIcon from "@material-ui/icons/OpenWithSharp";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import { useState, useEffect } from "react";
import React from "react";
import { CSVLink } from "react-csv";
import { KEY_PERFORMANCE_BY_AGENT as header } from "../../Utils/StaticData/DashboardHeader";
import Chart, { Ticks } from "chart.js/auto";
import { connect } from "react-redux";
import * as DateUtil from "../../Utils/DatePicker";
import { handleDateChange } from "../../Utils/DateFormatter";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { keyPerformanceByAgent } from "../../Redux/Actions/webAppActions";
import { getAgentPerformanceExport } from "../../Redux/Actions/ExportActions";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import AutoComplete1 from "../../Utils/Select";
const AgentModal = (props) => {
  const [expand, setExpand] = useState(true);
  const [categoryLabels, setcategoryLabels] = React.useState([[]]);
  const [StartDate, setStartDate] = React.useState("");
  const [EndDate, setEndDate] = React.useState("");
  const [categoryValues, setcategoryValues] = React.useState([[]]);
  const [PageIndex, setPageIndex] = useState(0);
  const [MaxPageIndex, setMaxPageIndex] = useState(0);
  const [csvData, setcsvData] = React.useState(
    props.keyPerformanceByAgentExport
  );
  const [excludeLegend, setLegend] = useState([]);
  const [showExportbtn, setshowExport] = useState(props.showExport);
  const [snackBarOpen, setsnackBarOpen] = useState(false);
  const [snackBarMsg, setsnackBarMsg] = useState("");
  const [vertical, setvertical] = useState("top");
  const [horizontal, sethorizontal] = useState("center");
  const [severity, setseverity] = useState("error");
  const [agentEmail, setAgentEmail] = useState([]);
  const [agentSummaryKey, setAgentSummaryKey] = useState();
  const defaultEmail = [{ label: "select", value: "" }];

  const handleSearch = async () => {
    setAgentSummaryKey(agentSummaryKey + 1);
    if (StartDate !== "") {
      if (EndDate === "") {
        setsnackBarOpen(true);
        setsnackBarMsg("End Date can't be empty.");
        setseverity("error");
        setvertical("top");
        sethorizontal("center");
        return;
      }
    } else {
      if (EndDate !== "") {
        if (StartDate === "") {
          setsnackBarOpen(true);
          setsnackBarMsg("Start Date can't be empty.");
          setseverity("error");
          setvertical("top");
          sethorizontal("center");
          return;
        }
      }
    }
    const emailArr = props?.allEmails
      ? props?.allEmails.filter(
          (data1) => agentEmail.indexOf(data1.value) !== -1
        )
      : [];
    await props.keyPerformanceByAgent({
      startDate: StartDate,
      endDate: EndDate,
      //agentList: emailArr.map((email) => email.label),
      agentList: emailArr.map((email) => email.userId),
    });
    await props.getAgentPerformanceExport({
      startDate: StartDate,
      endDate: EndDate,
      //agentList: emailArr.map((email) => email.label),
      agentList: emailArr.map((email) => email.userId),
    });
    setPageIndex(0);
  };
  const handleReset = async () => {
    setAgentSummaryKey(agentSummaryKey + 1);
    await props.keyPerformanceByAgent({
      startDate: "",
      endDate: "",
      agentList: [],
    });
    await props.getAgentPerformanceExport({
      startDate: "",
      endDate: "",
      agentList: [],
    });
    setPageIndex(0);
    setStartDate("");
    setEndDate("");
    setAgentEmail([]);
  };
  const handleResetClose = async () => {
    setStartDate("");
    setEndDate("");
    props.agentModalClose();
    setExpand(true);
    setPageIndex(0);
    setAgentEmail([]);
    await props.keyPerformanceByAgent({
      startDate: "",
      endDate: "",
      agentList: [],
    });
    await props.getAgentPerformanceExport({
      startDate: "",
      endDate: "",
      agentList: [],
    });
  };
  const handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    DateUtil.getDatePicker("#" + name).datepicker("hide");

    value = handleDateChange(value);
    if (name === "startDate1") {
      setStartDate(value);
    } else {
      setEndDate(value);
    }
    // DateUtil.getDatePicker("#" + name).datepicker("show");
  };
  const handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      setDates(fieldId, e.target.value);
    });
  };

  const setDates = async (fieldId, value) => {
    if (fieldId === "startDate1") {
      setStartDate(value);
    } else {
      setEndDate(value);
    }
  };
  const setData = (pieData, appData, Label, Value, type) => {
    let labelArray = [];
    let valueArray = [];

    if (type === "Category") {
      //loop to extract labels and values for chart from response(json)
      if (pieData !== undefined) {
        for (let i = 0; i < Object.keys(pieData).length; i++) {
          const label = pieData[i].label;
          const value = pieData[i].value;
          labelArray.push(label);
          valueArray.push(value);
        }

        let divideBY =
          labelArray.length / 20 + (labelArray.length % 20 > 0 ? 1 : 0);

        let j = 0,
          k = 1;
        if (divideBY > 0) {
          let labelsets = [];
          let datasets = [];
          for (let i = 1; i <= Math.floor(divideBY); i++) {
            let arr = "";

            if (i === divideBY) {
              arr = labelArray.slice(20 * j);
            } else {
              arr = labelArray.slice(20 * j, 20 * k);
            }
            labelsets[i - 1] = arr;
            j = j + 1;
            k = k + 1;
          }
          j = 0;
          k = 1;
          for (let i = 1; i <= Math.floor(divideBY); i++) {
            let arr = "";

            if (i === divideBY) {
              arr = valueArray.slice(20 * j);
            } else {
              arr = valueArray.slice(20 * j, 20 * k);
            }
            datasets[i - 1] = arr;
            j = j + 1;
            k = k + 1;
          }

          let max = Math.floor(divideBY);
          setMaxPageIndex(max);
          setcategoryLabels(labelsets);
          setcategoryValues(datasets);
        } else {
          setMaxPageIndex(0);
          setcategoryLabels([[]]);
          setcategoryValues([[]]);
        }
      }
      // setcategoryLabels(labelArray)
      // setcategoryValues(valueArray)
    }
  };
  const PaginationHandlerInitial = (e) => {
    if (MaxPageIndex > 1 && PageIndex > 0) {
      setPageIndex(0);
    }
  };
  const PaginationHandlerEnd = (e) => {
    if (MaxPageIndex > 1 && PageIndex !== MaxPageIndex - 1) {
      setPageIndex(MaxPageIndex - 1);
    }
  };
  const PaginationHandlerBack = (e) => {
    if (MaxPageIndex > 1 && PageIndex > 0) {
      setPageIndex(PageIndex - 1);
    }
  };
  const PaginationHandlerForward = (e) => {
    if (MaxPageIndex > 1 && PageIndex < MaxPageIndex - 1) {
      setPageIndex(PageIndex + 1);
    }
  };
  useEffect(() => {
    setData(
      props.KeyPerformanceByAgent,
      "applicationCategoryData",
      "categoryLabels",
      "categoryValues",
      "Category"
    );
    setcsvData(props.keyPerformanceByAgentExport);
    setshowExport(props.showExport);
    setAgentSummaryKey(props.agentSummaryKey);
  }, [props]);
  useEffect(() => {
    const categoryOptions = {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
          animation: true,
          position: "bottom",
          onClick: labelHandler,
          labels: {
            fontSize: 10,
            // generateLabels:(chart)=>{
            //   //console.log("chart",chart)
            //   let visibility=[];
            //   let hidden=[];
            //   for(let i=0;i<chart.data.labels.length;i++){
            //     if(chart.getDataVisibility(i)=== true){
            //     visibility.push('rgba(102,102,102,1)');
            //       hidden.push(false);
            //     }
            //     else{
            //       hidden.push(true);
            //     }
            //   }
            //   //console.table(visibility)
            //   return chart.data.labels.map(
            //     (label,index)=>({
            //       text:label,
            //       fillStyle:chart.data.datasets[0].backgroundColor[index],
            //       fontSize:25,
            //       fontColor:visibility[index],
            //         datasetIndex:index,
            //           //fontColor:visibility[index],
            //           hidden:hidden[index],
            //           lineDash:hidden[index]===true?[]:[0,0],
            //           borderRadius:2,
            //           strokeStyle:"black",
            //           lineCap:"butt"

            //     })
            //   )}
          },
          align: "start",
        },
        // legendCallback:(chart)=>{
        //   console.log("888888")
        //   let labels=chart.data.labels;
        //   let clr=chart.data.datasets[0].backgroundColor;
        //   return (
        //     <ul>
        //       {
        //         labels && labels.map((label,index)=>
        //           <li>
        //             <div>{label}</div>
        //           </li>
        //         )
        //       }
        //     </ul>
        //   )
        // },
        // layout:{
        //   padding:{
        //     left:0,
        //     right:0,
        //     top:0,
        //     bottom:0
        //   }
        // },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data1) => getTooltip(tooltipItem, data1),
          },
        },
        animation: false,
      },
      scales: {
        y: {
          title: {
            display: true,
            text: "No. Of  Enrollments",
            padding: 15,
          },
        },
      },
    };
    const categoryData = {
      labels: categoryLabels[PageIndex],
      datasets: [
        {
          data: categoryValues[PageIndex],
          label: "Enrollments",
          backgroundColor: [
            "#51b065",
            "#63b0a3",
            "#9b0f86",
            "#56609c",
            "#599651",
            "#a68465",
            "#996077",
            "#609099",
            "#fcba03",
            "#abebf6",
            "#996987",
            "#609090",
            "#fcba13",
            "#dddddd",
            "#99af87",
            "#609690",
            "#fcbe13",
            "#abeb4d",
          ],
          hoverBackgroundColor: [
            "#b9edc4",
            "#abede2",
            "#5a8f86",
            "#56609c",
            "#529651",
            "#a68465",
            "#996077",
            "#609099",
          ],
        },
      ],
    };
    //console.log("labels",categoryLabels,"values",categoryValues)
    let status = Chart.getChart("agentChart1");
    if (status != undefined) {
      status.destroy();
    }
    const ctx = document.getElementById("agentChart1");

    const config = {
      type: "line",
      data: categoryData,
      options: categoryOptions,
      // plugins:[{
      //   beforeInit:function(chart, args, options) {
      //     // Make sure we're applying the legend to the right chart
      //     if (chart.canvas.id === "agentChart") {
      //       const ul = document.createElement('ul');
      //       chart.data.labels.forEach((label, i) => {
      //         ul.innerHTML += `
      //           <li>
      //             <span style="background-color: ${ chart.data.datasets[0].backgroundColor[i] }">
      //               ${ chart.data.datasets[0].data[i] }
      //             </span>
      //             ${ label }
      //           </li>
      //         `;
      //       });

      //       return document.getElementById("legend").appendChild(ul);
      //     }

      //     return;
      //   }
      // }]
      //optiomychart.destroy()ns:categoryOptions
    };

    new Chart(ctx, config);
  }, [categoryLabels, categoryValues, props, PageIndex]);

  const getTooltip = (tooltipItem, data1) => {
    let index = tooltipItem.index;
    let label = data1.labels[index];
    let value = data1.datasets[0].data[index];
    if (label === "Cancelled") label = "Application is cancelled by plan";
    if (label === "Denied eligibillity") {
      label = "Application has been deemed not eligible by plan";
    }
    if (label === "Duplicate application") {
      label =
        "A duplicate application exists and currently being reviewed by plan";
    }
    if (label === "Eligibility review") {
      label = "The application eligibility is being reviewed";
    }
    if (label === "Incomplete") {
      label =
        "Application has incomplete information that is being reviewed by the plan";
    }
    if (label === "Being Submitted to CMS") {
      label =
        "The application is currently being submitted to CMS for approval";
    }
    if (label === "RFI") {
      label = "RFI has been initiated by plan";
    }
    return label + " : " + value + " ";
  };

  const labelHandler = (e, item, legend) => {
    // console.log("test",e,item,legend)
    const index = legend.chart.data.labels.indexOf(item.text);
    // console.log("index",index)
    legend.chart.toggleDataVisibility(index);
    legend.chart.update();
    if (excludeLegend.indexOf(item.text) === -1) {
      // console.log("no")
      let arr1 = excludeLegend;
      arr1.push(item.text);
      setLegend(arr1);
    } else {
      //console.log("yess")
      let x = excludeLegend.indexOf(item.text);
      let arr2 = excludeLegend.splice(x, 1);
      // console.log("arr",arr2)
      setLegend(arr2);
      setcsvData(props.keyPerformanceByAgentExport);
    }
    //console.log("excluded",excludeLegend)
    let exportArr = csvData;
    let arr = [];
    for (let i = 0; i < exportArr.length; i++) {
      let flag = false;
      for (let j = 0; j < excludeLegend.length; j++) {
        if (exportArr[i]?.agentMail === excludeLegend[j]) {
          flag = true;
          break;
        }
      }
      if (flag === false) {
        arr.push(exportArr[i]);
      }
    }
    setcsvData(arr);
    //console.log("export",arr)
  };
  const expandHandler = () => {
    setExpand(!expand);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setsnackBarOpen(false);
    setseverity("error");
  };

  const handleMultipleSelectionDropdown = (name) => async (data) => {
    let multipleValues = [];
    data.forEach((data1) => {
      multipleValues.push(data1.value);
    });

    if (agentEmail.length === 0 && multipleValues.indexOf("") !== -1) {
      multipleValues.splice(multipleValues.indexOf(""), 1);
    } else if (agentEmail.length > 0 && multipleValues.indexOf("") !== -1) {
      multipleValues = [];
    }

    await setAgentEmail(multipleValues);
  };

  return (
    <div class="modal" role="dialog" id="modal3" data-backdrop="static">
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
      >
        {
          <Alert onClose={handleClose} severity={severity}>
            {snackBarMsg}
          </Alert>
        }
      </Snackbar>
      <div
        class={
          expand
            ? "modal-dialog modal-xl modal-dialog-scrollable"
            : "modal-dialog modal-lg modal-dialog-scrollable"
        }
        key={agentSummaryKey}
      >
        <div class="modal-content">
          <div class="modal-header modal-header-background">
            <h4
              class={
                !expand
                  ? "modal-title header-position"
                  : "modal-title header-expand-position"
              }
            >
              {" "}
              Key Performance By Agent Summary
            </h4>

            {showExportbtn && props.KeyPerformanceByAgent?.length > 0 ? (
              <>
                <CSVLink
                  data={csvData}
                  filename={"KeyPerformanceByAgent.csv"}
                  className="btn btn-secondary4 pull-right icon-export mr-2"
                  headers={header}
                >
                  <i class="fa fa-share-square-o" /> Export
                </CSVLink>
              </>
            ) : null}
            <a
              class="pl-1 expand-icon-spacing"
              // data-toggle="modal"
              // data-target="#myModal1"
              onClick={expandHandler}
            >
              {!expand ? <OpenWithSharpIcon /> : <CompareArrowsIcon />}
            </a>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              onClick={handleResetClose}
            >
              &times;
            </button>
          </div>

          <div class="modal-body">
            {/* <div class="row"> */}
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div
                class="canvas-container mb-3 chartModal"
                style={{ height: !expand ? "390px" : "485px" }}
              >
                {/* Removed overflow-auto calss from here added conditional height */}
                {/* <div class="pie-chart-submitted"> */}
                <div
                  className={
                    expand
                      ? "expanded-modal-line-chart-container"
                      : "modal-line-chart-container"
                  }
                  id="agent1"
                >
                  {/* <PerformanceByAgent
                        KeyPerformanceByAgent={props.KeyPerformanceByAgent}
                        showExport={false}
                        updated={true}
                /> */}
                  <div className="mt-1">
                    {/* <div style={{display:"flex",flexDirection:"row"}}> */}
                    {/* <div id="legend" ></div> */}
                    <div>
                      <div class="d-flex flex-row justify-content-center">
                        <div
                          onClick={PaginationHandlerInitial}
                          className={
                            PageIndex === 0 ? "pagination-disable" : ""
                          }
                        >
                          <SkipPreviousIcon />
                        </div>
                        <div
                          onClick={PaginationHandlerBack}
                          className={
                            PageIndex === 0
                              ? "pagination-disable pagination-padding"
                              : "pagination-padding"
                          }
                        >
                          <ArrowLeftIcon />
                        </div>
                        <div
                          onClick={PaginationHandlerForward}
                          className={
                            MaxPageIndex <= 1 || PageIndex === MaxPageIndex - 1
                              ? "pagination-disable"
                              : ""
                          }
                        >
                          <ArrowRightIcon />
                        </div>
                        <div
                          onClick={PaginationHandlerEnd}
                          className={
                            MaxPageIndex <= 1 || PageIndex === MaxPageIndex - 1
                              ? "pagination-disable"
                              : ""
                          }
                        >
                          <SkipNextIcon />
                        </div>
                      </div>
                      <canvas id="agentChart1"></canvas>
                    </div>
                    {/* </div> */}
                    {/* <Chart
type="pie"
id="categorychart"
data={categoryData}
// width={pieWidth}
width={"500px"}
height={"500px"}
options={categoryOptions}
//ref={onRefChange}
// height={pieHeight}
ref={x}
/> */}
                  </div>
                </div>

                {/* </div> */}
              </div>

              {/* </div> */}
              <div class="row pad">
                <div class="col-lg-3 col-md-4 col-sm-8">
                  <label for="agentSummary" class="labelprospect">
                    Agent List:
                  </label>
                  <br />
                  <AutoComplete1
                    handleChange={handleMultipleSelectionDropdown(
                      "agentSummary"
                    )}
                    //label="Agent Email List"
                    multiple={true}
                    options={props?.allEmails ? props?.allEmails : []}
                    // disabled = "true"
                    defaultValue={defaultEmail}
                    value={
                      props?.allEmails
                        ? props?.allEmails.filter(
                            (data1) => agentEmail.indexOf(data1.value) !== -1
                          )
                        : []
                    }
                    name="agentSummary"
                    margin="20px auto"
                    width="100%"
                    show={true}
                  />
                </div>
                <div className="mr-4"></div>
                <div class="col-sm-3 col-md-4 col-lg-2">
                  <label for="startDate1" class="labelprospect">
                    Start Date:
                  </label>
                  <br />
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control1"
                    id="startDate1"
                    // readonly=""
                    name="startDate1"
                    value={StartDate}
                    maxLength="10"
                    onChange={handleDate}
                    onClick={(e) => handleDates("startDate1")}
                  />
                </div>
                <div class="col-sm-3 col-md-4 col-lg-2">
                  <label for="endDate1" class="labelprospect">
                    End Date:
                  </label>
                  <br />
                  <input
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                    type="text"
                    class="form-control1"
                    maxLength="10"
                    value={EndDate}
                    onChange={handleDate}
                    onClick={(e) => handleDates("endDate1")}
                    name="endDate1"
                    id="endDate1"
                    // onChange={props.handleChange}
                  />
                </div>
                <div className="mr-4"></div>
                <div class="col-sm-6 col-md-8 col-lg-3">
                  <br />
                  <div class="d-flex flex-row">
                    <button
                      class="btn-primary-continue mr-2"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                    {/* </div>
              <div class="col-sm-3 col-md-4 col-lg-1">
                <br /> */}
                    <button
                      class="btn-secondary-continue-dash"
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            {/* <button type="button" class="btn btn-close btn-secondary btn-secondary4 btn-chart-close" data-dismiss="modal" onClick={handleReset}>Close</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    PerformanceByAgent: state.webApp.PerformanceByAgent,
    keyPerformanceByAgentExport: state.export.keyPerformanceByAgentExport,
  };
};
const mapDispatchToProps = {
  //getAgentList,
  keyPerformanceByAgent,
  getAgentPerformanceExport,
};
export default connect(mapStateToProps, mapDispatchToProps)(AgentModal);
